<template>
  <section id="servicios" class="py-5 py-md-5 bg-white text-dark">
    <div class="container py-4">
      
      <div class="row mb-5 text-center">
        <div class="col-lg-8 mx-auto">
          <h2 class="display-5 fw-bold section-title-dark animate__fadeInDown">
            Soluciones Tecnológicas Integrales
          </h2>
          <p class="lead text-secondary animate__fadeInDown animate__delay-0s">
            Desde optimización y formateo hasta la recuperación de datos, tu equipo está en las mejores manos.
          </p>
        </div>
      </div>

      <div class="row g-4 justify-content-center">
        <div class="col-md-6 col-lg-4 d-flex">
          <div class="service-card animate__zoomIn animate__delay-1s p-4 h-100">
            <div class="icon-wrapper mb-4">
              <i class="bi bi-hdd-fill service-icon"></i>
            </div>
            <h3 class="fw-bold text-primary mb-3">Formateo y SO</h3>
            <p class="text-white-50">
              Reinstalación limpia de Windows, macOS o Linux. Optimizamos el sistema para un rendimiento impecable, libre de virus y archivos basura.
            </p>
            <a href="#contacto" class="btn btn-sm btn-outline-primary service-btn-hover">Saber Más</a>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 d-flex">
          <div class="service-card animate__zoomIn animate__delay-2s p-4 h-100">
            <div class="icon-wrapper mb-4">
              <i class="bi bi-bug-fill service-icon"></i>
            </div>
            <h3 class="fw-bold text-primary mb-3">Antivirus & Malware</h3>
            <p class="text-white-50">
              Eliminación profunda de todo tipo de amenazas. Instalación y configuración de software de seguridad premium para proteger tus datos.
            </p>
            <a href="#contacto" class="btn btn-sm btn-outline-primary service-btn-hover">Saber Más</a>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 d-flex">
          <div class="service-card animate__zoomIn animate__delay-3s p-4 h-100">
            <div class="icon-wrapper mb-4">
              <i class="bi bi-tools service-icon"></i>
            </div>
            <h3 class="fw-bold text-primary mb-3">Mantenimiento PC/Laptop</h3>
            <p class="text-white-50">
              Limpieza interna, cambio de pasta térmica, optimización de software. Extendemos la vida útil de tu equipo y mejoramos su velocidad.
            </p>
            <a href="#contacto" class="btn btn-sm btn-outline-primary service-btn-hover">Saber Más</a>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 d-flex">
          <div class="service-card animate__zoomIn animate__delay-4s p-4 h-100">
            <div class="icon-wrapper mb-4">
              <i class="bi bi-arrow-clockwise service-icon"></i>
            </div>
            <h3 class="fw-bold text-primary mb-3">Recuperación de Datos</h3>
            <p class="text-white-50">
              ¿Perdiste archivos importantes? Intentamos recuperar fotos, documentos y videos de discos duros dañados o formateados accidentalmente.
            </p>
            <a href="#contacto" class="btn btn-sm btn-outline-primary service-btn-hover">Saber Más</a>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 d-flex">
          <div class="service-card animate__zoomIn animate__delay-5s p-4 h-100">
            <div class="icon-wrapper mb-4">
              <i class="bi bi-cpu service-icon"></i>
            </div>
            <h3 class="fw-bold text-primary mb-3">Asesoría & Upgrades</h3>
            <p class="text-white-50">
              Mejora tu hardware (RAM, SSD, GPU) o software. Te asesoramos para que tu equipo se adapte a tus necesidades de rendimiento y presupuesto.
            </p>
            <a href="#contacto" class="btn btn-sm btn-outline-primary service-btn-hover">Saber Más</a>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 d-flex">
          <div class="service-card animate__zoomIn animate__delay-6s p-4 h-100">
            <div class="icon-wrapper mb-4">
              <i class="bi bi-wifi service-icon"></i>
            </div>
            <h3 class="fw-bold text-primary mb-3">Redes & Conexión</h3>
            <p class="text-white-50">
              Configuración de redes WiFi, solución de problemas de conexión a internet y optimización para el hogar o la oficina.
            </p>
            <a href="#contacto" class="btn btn-sm btn-outline-primary service-btn-hover">Saber Más</a>
          </div>
        </div>

      </div>

      <div class="row mt-5 pt-4 text-center">
          <div class="col-lg-8 mx-auto p-4 rounded-3 border border-primary cta-final-light animate__fadeInUp animate__delay-7s">
            <h3 class="fw-bold mb-3 text-dark">¿No encuentras lo que buscas? Contáctanos para una solución personalizada.</h3>
            <a 
                href="https://wa.me/584123659519" 
                target="_blank"
                class="btn btn-whatsapp-lg d-inline-flex align-items-center fw-bold shadow-lg"
            >
                <i class="bi bi-whatsapp me-2 fs-5"></i>
                ¡Consulta Aquí!
            </a>
          </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "NuestrosServicios",
  // Recuerda que estas animaciones requieren la importación de Animate.css
};
</script>

<style scoped>
/* IMPORTANTE: Requiere Animate.css para las clases 'animate__' */

/* === Sección General === */
.bg-white {
    background-color: #ffffff !important; 
}
.text-dark {
    color: #212529 !important;
}
.text-secondary {
    color: #5a5f64 !important;
}

/* === Título de Sección === */
.section-title-dark {
    color: #17171a;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
}

/* === Tarjetas de Servicio === */
.service-card {
    background-color: #1a1a2e; /* Fondo oscuro profundo para contraste */
    border-radius: 15px;
    padding: 2.5rem; /* Más padding para aire */
    border: 1px solid rgba(13, 110, 253, 0.2); 
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3); /* Sombra dramática */
    transition: all 0.4s ease-in-out; /* Transición suave para todos los cambios */
    text-align: center;
    overflow: hidden; /* Para efectos internos */
    position: relative;
    z-index: 1; /* Para la superposición de elementos */
}

.service-card::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(13, 110, 253, 0.1) 0%, transparent 70%);
    transform: scale(0);
    transition: transform 0.5s ease-in-out;
    z-index: 0;
}

.service-card:hover::before {
    transform: scale(1);
}

.service-card:hover {
    transform: translateY(-10px) scale(1.02); /* Efecto de levitación más pronunciado */
    border-color: #0d6efd;
    box-shadow: 0 15px 40px rgba(13, 110, 253, 0.4); /* Glow azul más intenso */
}

/* === Íconos de Servicio === */
.icon-wrapper {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 80px;
    background-color: rgba(13, 110, 253, 0.1); /* Fondo sutil para el ícono */
    border-radius: 50%;
    margin: 0 auto 1.5rem;
    box-shadow: 0 0 15px rgba(13, 110, 253, 0.3);
    transition: all 0.4s ease-in-out;
    z-index: 2; /* Para que el ícono esté por encima del pseudo-elemento */
}

.service-card:hover .icon-wrapper {
    background-color: #0d6efd;
    box-shadow: 0 0 25px rgba(13, 110, 253, 0.8);
    transform: rotateY(15deg) scale(1.1);
}

.service-icon {
    font-size: 3.5rem; /* Ícono grande */
    color: #0d6efd; /* Azul primario */
    transition: color 0.4s ease-in-out;
}

.service-card:hover .service-icon {
    color: white; /* Ícono blanco en hover */
}

/* === Títulos de Tarjetas === */
.service-card h3 {
    text-shadow: 0 0 8px rgba(13, 110, 253, 0.5); /* Glow sutil para el título */
}

/* === Descripciones de Tarjetas === */
.service-card p {
    color: rgba(255, 255, 255, 0.7) !important;
    margin-bottom: 1.5rem;
    font-size: 0.95rem;
}

/* === Botones de Tarjetas === */
.service-btn-hover {
    border-color: #0d6efd;
    color: #0d6efd;
    transition: all 0.3s ease-in-out;
}
.service-btn-hover:hover {
    background-color: #0d6efd;
    color: white;
    box-shadow: 0 0 10px rgba(13, 110, 253, 0.7);
    transform: translateY(-2px);
}

/* === CTA Final === */
.cta-final-light {
    background-color: #f0f8ff; /* Azul muy claro para destacar */
    border: 2px solid #0d6efd;
    transition: 0.5s;
    box-shadow: 0 5px 20px rgba(13, 110, 253, 0.1);
}
.cta-final-light:hover {
    background-color: #e6f2ff;
    transform: scale(1.01);
}

.btn-whatsapp-lg {
    background: #25D366;
    color: white;
    padding: 12px 30px;
    font-size: 1.1rem;
    border-radius: 10px;
    transition: 0.3s;
}
.btn-whatsapp-lg:hover {
    background: #1ebe5d;
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 0 15px rgba(37, 211, 102, 1);
}


/* === Animaciones de Entrada (Retardos Escalonados) === */
.animate__delay-0s { animation-delay: 0.0s; } 
.animate__delay-1s { animation-delay: 0.3s; } 
.animate__delay-2s { animation-delay: 0.6s; } 
.animate__delay-3s { animation-delay: 0.9s; } 
.animate__delay-4s { animation-delay: 1.2s; } 
.animate__delay-5s { animation-delay: 1.5s; } 
.animate__delay-6s { animation-delay: 1.8s; } 
.animate__delay-7s { animation-delay: 2.2s; /* CTA final con más retraso */ } 

/* Asegurarse de que las animaciones de entrada solo se ejecuten una vez */
.animate__zoomIn, .animate__fadeInDown, .animate__fadeInUp {
    animation-duration: 0.8s;
    animation-fill-mode: both; /* Mantiene el estado final de la animación */
}

/* === Responsive para Móviles === */
@media (max-width: 767.98px) {
    .section-title-dark {
        font-size: 2rem;
    }
    .service-card {
        padding: 1.8rem;
    }
    .service-icon {
        font-size: 3rem;
    }
    .icon-wrapper {
        width: 70px;
        height: 70px;
    }
    .service-card h3 {
        font-size: 1.4rem;
    }
    .service-card p {
        font-size: 0.875rem;
    }
    .btn-whatsapp-lg {
        width: 100%;
    }
}
</style>